import { render } from "./TabPlantSummary.vue?vue&type=template&id=91273218"
import script from "./TabPlantSummary.vue?vue&type=script&lang=js"
export * from "./TabPlantSummary.vue?vue&type=script&lang=js"

import "./TabPlantSummary.vue?vue&type=style&index=0&id=91273218&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__